<template>
  <div class="body">
    <div class="header">
      <div class="logo">
        <img src="@/assets/logo.jpg" style="float:left;height:100px;" />
        <img src="@/assets/tel.jpg" style="float:right;height:100px;" />
      </div>
      <div>
        <ul class="newUl">
          <li v-for="(row,index) in list" :key="index">
            <a href="javascript:;" @click="handel(index)" :class="{'active':currentIndex == index}">
				{{row.name}}
				<ul v-if="row.name == '企业介绍'" v-show="currentIndex == 1 || currentIndex == 7">
					<li>
						<a href="javascript:;" @click.stop="handel(7)" :class="{'active':currentIndex == 7}">案例展示</a>
					</li>
				</ul>
			</a>
		  </li>
        </ul>
      </div>
    </div>
    <vbody @customEvent="handleCustomEvent" @detail="changeDetail" v-if="currentIndex == 0"></vbody>
    <enterpriseIntroduce v-if="currentIndex == 1"></enterpriseIntroduce>
    <teamOfExperts v-if="currentIndex == 2"></teamOfExperts>
    <mentalKnowledge @customEvent="handleCustomEvent" v-if="currentIndex == 3"></mentalKnowledge>
    <connectUs v-if="currentIndex == 4"></connectUs>
	<caseView v-if="currentIndex == 7"></caseView>
    <vfooter @customEvent="handleCustomEvent"></vfooter>
  </div>
</template>

<script>
  import vfooter from './vfooter.vue';
  import vbody from './vbody.vue';
  import enterpriseIntroduce from './enterpriseIntroduce.vue';
  import teamOfExperts from './teamOfExperts.vue';
  import mentalKnowledge from './mentalKnowledge.vue';
  import connectUs from './connectUs.vue';
  import caseView from './caseView.vue';
  export default {
    name: 'home',
    components: {
      vfooter,
      vbody,
      enterpriseIntroduce,
      teamOfExperts,
      mentalKnowledge,
      connectUs,
	  caseView
    },

    data() {
      return {
        list: [{
            name: '首页'
          },
          {
            name: '企业介绍'
          },
          {
            name: '专家团队'
          },
          {
            name: '心理知识'
          },
          {
            name: '联系我们'
          }
        ],

        currentIndex: 0,
        title: "",
      }
    },
    methods: {
      handel(index) {
        this.currentIndex = index;
		console.log(index)
        localStorage.clear();
        // this.$emit("customEvent", index);
      },
      handleCustomEvent(data) {
        this.currentIndex = data;
      },
      changeDetail(title) {
        this.title = title;
      }
    }
  }
</script>

<style scoped>
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
  }

  a {
    color: #42b983;
  }

  .header {
    width: 950px;
    margin: auto;
  }

  .logo {
    height: 100px;
  }

  .newUl {
    width: 950px;
    display: block;
    height: 46px;
  }

  .newUl li {
    float: left;
    line-height: 46px;
    height: 46px;
    width: 190px;
    text-align: center;
  }

  .newUl li a {
    display: inline-block;
    height: 46px;
    line-height: 46px;
    width: 100%;
    color: #333;
    font-size: 16px;
	position:relative
  }

  .newUl li a.active {
    background: #23B6B0;
    color: #fff;
  }
  .newUl li a ul{position:absolute;background:#fff;}
</style>



// WEBPACK FOOTER //
// src/components/home.vue